import { useSuspenseQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import { queryKey } from '../../../../../constant/queryKey';

export const useGoodsReviews = () => {
  const sno = useGoodsSno();
  return useSuspenseQuery({
    queryKey: queryKey.goodsReviews(sno),
    queryFn: () => goodsService.getGoodsReviews(sno),
  });
};
